import { USER_ROLES } from "../../constants";
import parseAppKey from "../routeHelpers/parseAppKey";

const UserHasPermission = (user, levelRequired) => {
	let appKey = parseAppKey();
	let userApp = user.apps.find(app => app.key === appKey);
	if (userApp) {
		return USER_ROLES.children[userApp.role].includes(levelRequired);
	}
	return false;
};

export default UserHasPermission;
